import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier } from './drupal-node.model';

export interface DrupalTreeItem {
  type: string;
  id: string;
  title: string;
  path: string | undefined;
  weight: number;
  parentId: string;
  description: string;
}

export class DrupalMenuItem extends DrupalIdentifier implements DrupalTreeItem {
  @Transform(({ obj }) => {
    return obj?.attributes?.label;
  })
  @Expose()
  title!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.langcode;
  })
  @Expose()
  language!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.weight;
  })
  @Expose()
  weight!: number;

  @Transform(({ obj }) => {
    return obj?.attributes?.path?.url;
  })
  @Expose()
  path!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.description;
  })
  @Expose()
  description!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.parentIs?.split(':').pop();
  })
  @Expose()
  parentId!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.classname;
  })
  @Expose()
  className!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.icon_id;
  })
  @Expose()
  iconId!: string;

  @Transform(({ obj }) => {
    return obj?.meta || undefined;
  })
  @Expose()
  meta!: any | undefined;
}
